const mFeedProductsContentModalDelete = {
  mFeedProductsContentModalDelete: {
    alerts: {
      deleteProducto: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El producto fue eliminado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el producto',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Producto'
  }
}

export default mFeedProductsContentModalDelete
